import React from "react";
import LgvRadioGroup from "../../../components/LgvRadioGroup";
import { QuestionItem } from "../../../types/form";
import {
  normalizeQuestionRadioOptions,
  shouldUseTwoOptionRadioCards,
} from "../../../utils/radioOptions";
import YesNoFieldRenderer from "./YesNoFieldRenderer";

interface RadioFieldRendererProps {
  question: QuestionItem;
  questionType: string;
  inputName: string;
  currentValue: unknown;
  setFormData: React.Dispatch<React.SetStateAction<Record<string, any>>>;
  readOnly?: boolean;
  onOpenHintsWithHint?: (
    hint: { title?: string; content: string } | null,
  ) => void;
}

const RadioFieldRenderer: React.FC<RadioFieldRendererProps> = ({
  question,
  questionType,
  inputName,
  currentValue,
  setFormData,
  readOnly = false,
  onOpenHintsWithHint,
}) => {
  const options = normalizeQuestionRadioOptions(question.options);

  if (questionType === "yes_no" || questionType === "boolean") {
    return (
      <YesNoFieldRenderer
        question={question}
        inputName={inputName}
        currentValue={currentValue}
        setFormData={setFormData}
        readOnly={readOnly}
      />
    );
  }

  if (shouldUseTwoOptionRadioCards(options)) {
    return (
      <YesNoFieldRenderer
        question={question}
        inputName={inputName}
        currentValue={currentValue}
        options={options}
        setFormData={setFormData}
        readOnly={readOnly}
      />
    );
  }

  return (
    <LgvRadioGroup
      name={inputName}
      value={currentValue}
      options={options}
      disabled={readOnly}
      required={question.isRequired}
      onChange={(value) =>
        setFormData((prev) => ({
          ...prev,
          [inputName]: value,
        }))
      }
      onOptionHintClick={
        onOpenHintsWithHint
          ? (hint) => onOpenHintsWithHint(hint)
          : undefined
      }
    />
  );
};

export default RadioFieldRenderer;
